import { toast } from 'material-react-toastify';
import { useTranslation } from 'react-i18next';

import { useDeleteCustomer } from '~/models/Customer/hooks/useDeleteCustomer';
import { NotFoundError, ValidationError } from '~/types/error';

import { ConfirmationDialog } from '../ConfirmationDialog';

type Props = {
  id: number;
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
};

export const DeleteCustomerDialog = ({ id, open, onClose, onSuccess }: Props) => {
  const { t } = useTranslation();
  const { mutateAsync, isLoading } = useDeleteCustomer({
    onSuccess: () => {
      toast.success(t('msg_success_customer_deleted'));
      onClose();

      if (onSuccess) {
        onSuccess();
      }
    },
  });

  const onDelete = async () => {
    try {
      await mutateAsync(id);
    } catch (error) {
      if ((error instanceof ValidationError || error instanceof NotFoundError) && error.detail) {
        toast.error(t(error.detail));
      }
    }
  };

  return (
    <ConfirmationDialog
      open={open}
      title={t('msg_title_delete_customer')}
      onClose={onClose}
      actions={[
        {
          label: t('msg_btn_delete_customer_confirm'),
          color: 'error',
          onClick: onDelete,
          showIsLoading: true,
        },
        {
          label: t('msg_btn_delete_customer_cancel'),
          onClick: onClose,
          color: 'inherit',
        },
      ]}
      isLoading={isLoading}
    />
  );
};
